/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React, { useMemo } from 'react';
import { Grid, List, Segment, Image, Container } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import isEqual from 'lodash/isEqual';
import { flattenHTMLToAppURL, flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import logoParmaInfanzia from 'assets/images/logo-parma-infanzia-bianco-150.png';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

const Footer = ({ intl }) => {
  const footerData = useSelector(
    (state) => state.editableFooterColumns?.result?.[0],
    isEqual,
  );

  const visibleItems = useMemo(() => {
    return footerData?.items?.filter((item) => item.visible && item.title) || [];
  }, [footerData]);

  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      style={{ backgroundColor: '#1770be' }}
      textAlign="center"
      id="footer"
      aria-label="Footer"
      tabIndex="-1"
    >
      <Container>
        <Grid columns={4} stackable inverted container={false}>
          {/* Colonna logo */}
          <Grid.Column>
            <Image src={logoParmaInfanzia} size="small" alt="ItCity Spa" />
          </Grid.Column>

          {/* Colonna info società */}
          <Grid.Column textAlign="left">
            <p>
              <strong>ParmaInfanzia S.p.A.</strong><br />
              Società controllata e coordinata dal Comune di Parma<br />
              Cod. Fisc. e P.I. 02272230349<br />
              R.E.A. Parma 224524<br />
              Cap. Soc. € 1.781.300,00 i.v.<br />
              <br /><br />
              Sede legale: Via Budellungo, 45/A<br />
              43123 Parma<br />
              Telefono: 0521.600150<br />
              Sede amministrativa: Via Colorno, 63<br />
              43122 Parma<br />
              Email info@parmainfanzia.it<br />
              PEC parmainfanzia@legalmail.it<br />
            </p>
          </Grid.Column>

          {visibleItems.length > 0 && (
            <>
              <Grid.Column
                textAlign="left"
                style={{
                  paddingLeft: '4rem',
                  // eventuali altri stili
                }}
              >
                <List link inverted>
                  {/* Faccio vedere le prime 3 voci */}
                  {visibleItems.slice(0, 3).map((item) => (
                    <List.Item key={item.id}>
                      {item.titleLink?.[0]?.getURL ? (
                        <a href={flattenToAppURL(item.titleLink[0].getURL)} className='item'>{item.title}</a>
                      ) : (
                        <p>{item.title}</p>
                      )}
                      {item.text && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: flattenHTMLToAppURL(item.text.data),
                          }}
                        />
                      )}
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>
              <Grid.Column textAlign="left">
                <List link inverted>
                  {/* Faccio vedere le voci da 4 in poi*/}
                  {visibleItems.slice(3, 10).map((item) => (
                    <List.Item key={item.id}>
                      {item.titleLink?.[0]?.getURL ? (
                        <a href={flattenToAppURL(item.titleLink[0].getURL)} className='item'>{item.title}</a>
                      ) : (
                        <p>{item.title}</p>
                      )}
                      {item.text && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: flattenHTMLToAppURL(item.text.data),
                          }}
                        />
                      )}
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>
            </>
          )}

        </Grid>

        {/* Copyright */}
        <Segment basic inverted style={{ backgroundColor: '#1770be' }} textAlign="right">
          © 2025 - It.City S.p.A
        </Segment>
      </Container>
    </Segment>
  );
};

export default injectIntl(Footer);